import {runProcedure} from '../../../services/webSdk/proc';
import {EditField, InputFieldsReturn} from 'priority-web-sdk';
import {Form} from '../../../stores/Form';
import {addNewStandAloneForm} from '../../Form/actions/standAloneForm';

export const runNumerationTemplatesProc = async (year: string) => {
    await runProcedure('DOCPAT', updateInputFields(year), undefined);
};

export const getNumerationTemplatesForm = (year: string): Promise<Form> => {
    return addNewStandAloneForm('DOCPAT', {PATYEAR: year}, undefined, 0);
};

export const getBranchesForm = (): Promise<Form> => {
    return addNewStandAloneForm('BRANCHES', {}, undefined, 0);
};

const updateInputFields =
    (year: string) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            switch (field.field) {
                case 1:
                    value = year;
                    break;
                case 2:
                    value = 'Y';
                    break;
                case 3:
                    value = 'N';
                    break;
            }

            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };
